import { DragDropProvider } from '../../DragDrop'

function TableDroppableBody({ children, droppableProps, ...restProps }) {
  return (
    <DragDropProvider {...restProps} {...droppableProps}>
      {children}
    </DragDropProvider>
  )
}

export default TableDroppableBody
